import React from 'react';
import { useParams } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { CtaBand } from '../components/shared/CtaBand';
import { blogPosts } from '../data/blog';
import { NotFound } from './NotFound';
export function BlogPost() {
  const {
    slug
  } = useParams();
  const post = blogPosts.find(p => p.slug === slug);
  if (!post) return <NotFound data-id="element-638" data-mp="3fe37hzinjmkg" />;
  return <>
      <Seo title={post.title} description={post.excerpt} data-id="element-639" data-mp="3agux4l3qwmtr" />
      <PageHero title={post.title} sub={`${post.category} · ${format(parseISO(post.date), 'MMMM d, yyyy')} · ${post.readTime}`} image={post.image} crumbs={[{
      label: 'Blog',
      to: '/blog'
    }, {
      label: post.category
    }]} data-id="element-640" data-mp="3ajh3wiitayax" />
      <article className="gutter section bg-white" data-id="element-641" data-mp="14oeebf3aisz4">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-642" data-mp="14nwbfzm4hgi8">
          <p className="t-lead font-medium text-navy lg:col-span-4" data-id="element-643" data-mp="zpl3xvjavi36">{post.excerpt}</p>
          <div className="space-y-6 text-[18px] leading-[1.75] text-ink lg:col-span-8 xl:col-span-7" data-id="element-644" data-mp="11527e2eiljua">
            {post.body.map(para => <p key={para.slice(0, 24)} data-id="element-645" data-mp="16584vz7gu0ka">{para}</p>)}
          </div>
        </div>
      </article>
      <CtaBand data-id="element-646" data-mp="s5p3rqd2nphh" />
    </>;
}